/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Live_Caption_Youtube_Warning_TitleInputs */

const en_live_caption_youtube_warning_title = /** @type {(inputs: Live_Caption_Youtube_Warning_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use a separate audio source.`)
};

const fr_live_caption_youtube_warning_title = /** @type {(inputs: Live_Caption_Youtube_Warning_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utilisez une source audio distincte.`)
};

const de_live_caption_youtube_warning_title = /** @type {(inputs: Live_Caption_Youtube_Warning_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verwenden Sie eine separate Audioquelle.`)
};

const it_live_caption_youtube_warning_title = /** @type {(inputs: Live_Caption_Youtube_Warning_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utilizzare una sorgente audio separata.`)
};

const ru_live_caption_youtube_warning_title = /** @type {(inputs: Live_Caption_Youtube_Warning_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Используйте отдельный источник звука.`)
};

const es_live_caption_youtube_warning_title = /** @type {(inputs: Live_Caption_Youtube_Warning_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utilice una fuente de audio independiente.`)
};

const zh_cn2_live_caption_youtube_warning_title = /** @type {(inputs: Live_Caption_Youtube_Warning_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`使用单独的音频源。`)
};

const ja_live_caption_youtube_warning_title = /** @type {(inputs: Live_Caption_Youtube_Warning_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`別の音声ソースを使用してください。`)
};

const hi_live_caption_youtube_warning_title = /** @type {(inputs: Live_Caption_Youtube_Warning_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`किसी अलग ऑडियो स्रोत का उपयोग करें।`)
};

const pt_pt2_live_caption_youtube_warning_title = /** @type {(inputs: Live_Caption_Youtube_Warning_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utilize uma fonte de áudio separada.`)
};

/**
* | output |
* | --- |
* | "Use a separate audio source." |
*
* @param {Live_Caption_Youtube_Warning_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const live_caption_youtube_warning_title = /** @type {((inputs?: Live_Caption_Youtube_Warning_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Live_Caption_Youtube_Warning_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_live_caption_youtube_warning_title(inputs)
	if (locale === "de") return de_live_caption_youtube_warning_title(inputs)
	if (locale === "it") return it_live_caption_youtube_warning_title(inputs)
	if (locale === "ru") return ru_live_caption_youtube_warning_title(inputs)
	if (locale === "es") return es_live_caption_youtube_warning_title(inputs)
	if (locale === "zh-CN") return zh_cn2_live_caption_youtube_warning_title(inputs)
	if (locale === "ja") return ja_live_caption_youtube_warning_title(inputs)
	if (locale === "hi") return hi_live_caption_youtube_warning_title(inputs)
	if (locale === "pt-PT") return pt_pt2_live_caption_youtube_warning_title(inputs)
	return en_live_caption_youtube_warning_title(inputs)
});